module.exports = __webpack_public_path__ + "static/media/figtree-latin-800.33527148.woff2";